import { Link } from "react-router-dom";

import { useIsLoadingVisibile } from "@utils/hooks/useIsLoadingVisible";
import { Skeleton } from "@ui/skeleton";

import { createComponentElement } from "../creators/createComponentElement";
import { useComponentData } from "../hooks/useComponentData";
import { ContentComponent } from "../types";
import { getPublicMediaUrl } from "@modules/api/util/mediaHelper";

const Component = createComponentElement((props, ref) => {
  const { getParameterValues, content, isLoading, ...other } =
    useComponentData<{ background: string; link: string }>(props, ref);

  const { background, link } = getParameterValues(["background", "link"]);

  const isLoadingVisible = useIsLoadingVisibile(isLoading && !link);

  return (
    <div className="relative w-full px-10 pb-[35px]">
      <div className="absolute top-0 w-full px-10 ltr:left-0 rtl:right-0">
        <RamadanContentLoading isLoading={isLoadingVisible} />
      </div>
      {link ? (
        <Link
          to={`/cc?type=pg-ramadan&id=${
            link?.split("wajeez://page/PG:RAMADAN/")?.[1]
          }`}
        >
          <img
            src={getPublicMediaUrl(background)}
            alt="ramadan"
            className="h-full w-full"
          />
        </Link>
      ) : content ? (
        <div
          className="flex w-full cursor-pointer flex-col justify-center gap-3"
          onClick={() => {
            props.onItemPress(
              content,
              {
                image: content?.parameters?.[1].valueV2,
              },
              { isLocked: false }
            );
          }}
        >
          <div className="text-[24px] font-medium text-ramadan-primary dark:text-dark-ramadan-primary">
            {content.title}
          </div>
          <div className="h-[304px] w-full">
            <img
              src={getPublicMediaUrl(background)}
              alt="movie"
              className="h-full w-full"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
});

const RamadanContentLoading = ({ isLoading }: { isLoading: boolean }) => {
  return isLoading ? (
    <Skeleton
      className={`h-[375px] w-full rounded-[12px] bg-[#f4f4f5] dark:bg-[#27272a]`}
    ></Skeleton>
  ) : null;
};

export const RamadanContentComponent: ContentComponent = {
  identifier: "COM:WAJEEZ:CARD",
  component: Component,
};
